/**
 * Create Company Page
 * MEMBER can submit a request to create a new company
 * Requires ADMIN approval
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import CreateCompanyForm from '../components/company/CreateCompanyForm';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { FiArrowLeft, FiInfo } from 'react-icons/fi';

const CreateCompanyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="เพิ่มบริษัทใหม่ | Thai Security Directory"
        description="ส่งคำขอเพิ่มบริษัทรักษาความปลอดภัยใหม่เข้าสู่ระบบ"
        url="/create-company"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-gray-50 py-8"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-8">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/my-companies')}
              className="mb-4"
              leftIcon={<FiArrowLeft />}
            >
              กลับไปหน้าบริษัทของฉัน
            </Button>

            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              เพิ่มบริษัทใหม่
            </h1>
            <p className="text-gray-600">
              กรอกข้อมูลบริษัทรักษาความปลอดภัยที่คุณต้องการเพิ่มเข้าสู่ระบบ
            </p>
          </div>

          {/* Info Card */}
          <Card className="mb-6 bg-blue-50 border-blue-200">
            <div className="flex items-start space-x-3 p-4">
              <FiInfo className="text-blue-600 text-xl flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <h3 className="font-semibold text-blue-900 mb-1">
                  เกี่ยวกับการเพิ่มบริษัทใหม่
                </h3>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• คำขอของคุณจะถูกส่งไปยังผู้ดูแลระบบเพื่อตรวจสอบ</li>
                  <li>• กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง</li>
                  <li>• หลังจากได้รับการอนุมัติ คุณจะเป็นเจ้าของบริษัทนี้โดยอัตโนมัติ</li>
                  <li>• คุณสามารถติดตามสถานะคำขอได้ที่หน้า "คำขอของฉัน"</li>
                </ul>
              </div>
            </div>
          </Card>

          {/* Form */}
          <Card className="p-6">
            <CreateCompanyForm />
          </Card>
        </div>
      </motion.div>
    </>
  );
};

export default CreateCompanyPage;
